import { render, staticRenderFns } from "./ProjectAppointIndex.vue?vue&type=template&id=08a53dc7&scoped=true&"
import script from "./ProjectAppointIndex.vue?vue&type=script&lang=js&"
export * from "./ProjectAppointIndex.vue?vue&type=script&lang=js&"
import style0 from "./ProjectAppointIndex.vue?vue&type=style&index=0&id=08a53dc7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a53dc7",
  null
  
)

export default component.exports